module.exports = __webpack_public_path__ + "static/img/nolike.a5b07ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nolike.png
// module id = yhsj
// module chunks = 4